<template>
<div>
	<div class="panel panel-default" v-if="!isUpdate">
  		<ly-fixheader title="查看管理公司信息" btn="edit">
  			<div class="btn-group pull-right pr15" v-if="info.status==1" slot="s2" @click="disable()">
				<a href="javascript:;" class="btn btn-block btn-primary pull-right"> 
					停用
				</a>
			</div>
  			<div class="btn-group pull-right pr15" v-if="info.status==0" slot="s2" @click="enable()">
				<a href="javascript:;" class="btn btn-block btn-primary pull-right"> 
					启用
				</a>
			</div>
			<div class="btn-group pull-right pr15" v-if="info.status=='-1'||info.status==1" slot="s3" @click="renewals()">
				<a href="javascript:;" class="btn btn-block btn-primary pull-right"> 
					续费
				</a>
			</div>
  		</ly-fixheader>
  		<div class="panel-body">
			<form class="form-horizontal">
				<div class="form-group">
					<label class="col-sm-2 control-label">名称:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.name}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">状态:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.status | statusfilter}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">编号:</label>
					<div class="col-sm-10">
						<label class="control-label" v-if="info.code">{{info.code}}</label>
						<label class="control-label" v-else>无</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">到期时间:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.expire}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">预分类:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.classify}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">区域:</label>
					<div class="col-sm-10">
						<label class="control-label">
							{{area}}
						</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">详细地址:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.address}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">管理公司负责人:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.companyer}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">管理公司电话:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.company_phone}}</label>
					</div>
				</div>
			  	<div class="form-hr"></div>
				<div class="form-group">
					<label class="col-sm-2 control-label">最大建店数:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.create_shop_max}}</label>
					</div>
				</div>
			  	<div class="form-hr"></div>
				<div class="form-group">
					<label class="col-sm-2 control-label">公司执照号:</label>
					<div class="col-sm-10">
						<label class="control-label" v-if="info.business_license_no">{{info.business_license_no}}</label>
						<label class="control-label" v-else>无</label>
					</div>
				</div>
				<div class="form-group" v-if="info.license_img">
					<label class="col-sm-2 control-label">执照照片:</label>
					<div class="col-sm-10">
						<img class="imgsize" :src="info.license_img">
					</div>
				</div>
			  	<div class="form-hr"></div>
				<div class="form-group">
					<label class="col-sm-2 control-label">公司管理员姓名:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.manage_admin}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">管理员账户:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.manage_phone}}</label>
					</div>
				</div>
			  	<div class="form-hr"></div>
				<div class="form-group">
					<label class="col-sm-2 control-label">分配域名:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.domain_name}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">负责BD:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.BD}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">是否可使用手机端:</label>
					<div class="col-sm-10">
						<label class="control-label" v-if="info.is_phone==1">可使用</label>
				    	<label class="control-label" v-if="info.is_phone==2">不可使用</label>	    	
					</div>
				</div>
				<div class="form-hr"></div>
				<div class="form-group">
					<label class="col-sm-2 control-label">操作:</label>
					<div class="col-sm-10">
						<p v-for="item in info.operationRecords">{{item.time+' '+item.operation}}</p>  	    	
					</div>
				</div>
			</form>
		</div>
  	</div>
  	<ly-companyupdate v-if="isUpdate" :info="info"></ly-companyupdate>
  	<!-- <ly-enablev-onv-on:newRenewal="newStatus":newDisable="newStatus" :information="ID" v-on:newEnable="newStatus" v-ref:enable></ly-enable> -->
	<ly-disable :ids="ID"  v-ref:disable></ly-disable>
	<ly-renewals :renew="ID"  v-ref:renewals></ly-renewals>
 </div>
</template>
<script>
	var Http = require('../utils/HttpHelper.js');
	var Com = require('../utils/Common.js');
	var info = {};//公司详情
	module.exports = {
		data : function(){
			return {
				isUpdate : false,
				info : {},
				area: "",
				ID:'',
				cid:'',
			}
		},
		components : {
			'ly-companyupdate' : require('./company_add.vue'),
			'ly-fixheader' : require('../components/Fixheader.vue'),
			/*'ly-enable' : require('../components/install/enable.vue'),*/
			'ly-disable' : require('../components/install/disable.vue'),
			'ly-renewals' : require('../components/install/Renewals.vue')
		},
		ready : function () {
			console.log("ready");
			var self = this;
			this.cid = this.$route.params['cid'];//获得公司的ID
			Http['company'].query({
				key : [self.cid],
				succ : function(rs){
					rs['id'] = self.cid;
					self.$set('info',rs);
					self.area = rs.area.join('');
				}
			});
		},
		filters: {
			statusfilter:function(str){
				var out = '';
				switch(str){
					case 1:
						out = '正常';
						break;
					case 0:
						out = '停用';
						break;
					case -1:
						out = '过期';
						break;
				}
				return out;
			}
		},
		methods:{
			/*
			* 启用
			*/
			enable:function(){
				/*this.ID = JSON.stringify(this.info);
				this.$refs.enable.show();*/
				var self = this;
				Com.confirm('确认启用该门店？',function(){
					var data_ = {
						company_id:self.cid,//管理公司id
						type:1,//1是开 0是停用
						stop_reason:'',//停用时传值
					};
					Http['statusChange'].create({
						key:[],
						data:data_,
						succ:function(rs){
							self.info.status =rs.now_status;
						}
					})
				});
			},
			disable:function(){
				this.ID = this.$route.params['cid'];
				this.$refs.disable.show();
			},
			renewals:function(){
				//console.log(rs.name);
				this.ID = JSON.stringify(this.info);
				this.$refs.renewals.show();
			}
		},
		events : {
			doUpdate : function(){
				this.isUpdate = true;
			},
			closeUpdate : function(){
				this.isUpdate = false;
			},
			goback: function(){
				Com.go('');
			},
			newDisable:function(rs){
				this.info.status = rs;
			},
			newRenewal:function(rs){
				this.info.status = rs.status;
				this.info.expire = rs.expiration_time;
			},
			expiration:function(rs){
				this.info.expire = rs;
			}
		}
	};
</script>


/** WEBPACK FOOTER **
 ** company_info.vue?9e8cca08
 **/